
export const DEFAULT_RANGE = {
  min: 75,
  max: 750,
};

type ValidateWeightParams = {
  currentWeight: number;
  value: number;
  range?: { min: number; max: number };
  isLowerWeightQuestion?: boolean;
};

export const validateWeight = ({
  currentWeight,
  value,
  range = DEFAULT_RANGE,
  isLowerWeightQuestion = false
}: ValidateWeightParams) => {
  const errorMessages = {
    min: `Must be at least ${range.min}lbs.`,
    max: `Must be less than ${range.max}lbs.`,
  };

  if (value < range.min) return errorMessages.min;
  if (value > range.max) return errorMessages.max;
  if (!currentWeight) return null;

  if (isLowerWeightQuestion && value >= currentWeight) {
    return `Must be lower than your current weight (${currentWeight} lbs.)`;
  }

  if (!isLowerWeightQuestion && value < currentWeight) {
    return `Must be equal to or higher than your current weight (${currentWeight} lbs.)`;
  }

  return null;
};

export const getWeightTooHighError = (max: number = DEFAULT_RANGE.max) =>
  `Weight must be less than ${max}lbs.`;

export const getWeightTooLowError = (min: number = DEFAULT_RANGE.min) =>
  `Weight must be at least ${min}lbs.`;
